import plugin from "tailwindcss/plugin";
const swsPlugin = plugin(({}) => {
}, {
  theme: {
    colors: {
      p: {
        white: {
          100: "var(--s-color-p-white-100)",
          110: "var(--s-color-p-white-110)",
          120: "var(--s-color-p-white-120)",
          130: "var(--s-color-p-white-130)",
          170: "var(--s-color-p-white-170)"
        },
        blue: {
          100: "var(--s-color-p-blue-100)",
          110: "var(--s-color-p-blue-110)",
          120: "var(--s-color-p-blue-120)"
        },
        red: {
          100: "var(--s-color-p-red-100)"
        },
        green: {
          100: "var(--s-color-p-green-100)"
        },
        orange: {
          100: "var(--s-color-p-orange-100)"
        },
        yellow: {
          100: "var(--s-color-p-yellow-100)"
        },
        purple: {
          100: "var(--s-color-p-purple-100)"
        },
        grey: {
          10: "var(--s-color-p-grey-10)",
          50: "var(--s-color-p-grey-50)",
          100: "var(--s-color-p-grey-100)",
          120: "var(--s-color-p-grey-120)"
        }
      },
      accent: "var(--s-color-accent)",
      transparent: {
        strong: "var(--s-color-transparent-strong)",
        subtle: "var(--s-color-transparent-subtle)"
      },
      attention: {
        DEFAULT: "var(--s-color-attention)",
        subtle: "var(--s-color-attention-subtle)"
      },
      good: {
        DEFAULT: "var(--s-color-good)",
        subtle: "var(--s-color-good-subtle)"
      },
      bad: {
        DEFAULT: "var(--s-color-bad)",
        subtle: "var(--s-color-bad-subtle)"
      },
      warning: {
        DEFAULT: "var(--s-color-warning)",
        subtle: "var(--s-color-warning-subtle)"
      }
    },
    // Override spacing as it uses rem by default, which doesn't jive well with our
    // root font size being 10px.
    // TODO: resolve and convert back to rem.
    spacing: {
      "0": "0px",
      px: "1px",
      "0.5": "2px",
      "1": "4px",
      "1.5": "6px",
      "2": "8px",
      "2.5": "10px",
      "3": "12px",
      "3.5": "14px",
      "4": "16px",
      "5": "20px",
      "6": "24px",
      "7": "28px",
      "8": "32px",
      "9": "36px",
      "10": "40px",
      "11": "44px",
      "12": "48px",
      "14": "56px",
      "16": "64px",
      "20": "80px",
      "24": "96px",
      "28": "112px",
      "32": "128px",
      "36": "144px",
      "40": "160px",
      "44": "176px",
      "48": "192px",
      "52": "208px",
      "56": "224px",
      "60": "240px",
      "64": "256px",
      "72": "288px",
      "80": "320px",
      "96": "384px"
    },
    // Override border radius as it uses rem by default, which doesn't jive well with our
    // root font size being 10px.
    // TODO: resolve and convert back to rem.
    borderRadius: {
      none: "0px",
      sm: "2px",
      DEFAULT: "4px",
      md: "6px",
      lg: "8px",
      xl: "12px",
      "2xl": "16px",
      "3xl": "24px",
      full: "9999px"
    },
    fontSize: {
      xs: ["12px", "16px"],
      sm: ["14px", "20px"],
      base: ["16px", "24px"],
      lg: ["18px", "28px"],
      xl: ["20px", "28px"],
      "2xl": ["24px", "32px"],
      "3xl": ["30px", "36px"],
      "4xl": ["36px", "40px"],
      "5xl": ["48px", "1"],
      "6xl": ["60px", "1"],
      "7xl": ["72px", "1"],
      "8xl": ["96px", "1"],
      "9xl": ["128px", "1"]
    },
    extend: {
      backgroundColor: {
        surface: {
          DEFAULT: "var(--s-color-surface)",
          "1": "var(--s-color-surface-1)",
          "2": "var(--s-color-surface-2)"
        }
      },
      borderColor: {
        strong: "var(--s-color-border-strong)"
      },
      textColor: {
        solid: "var(--s-color-text-solid)",
        soft: "var(--s-color-text-soft)",
        subtle: "var(--s-color-text-subtle)"
      }
    }
  }
});
export {
  swsPlugin
};
